import React from 'react';
import css from './AboutWine.module.css';
import {
  AlertIcon,
  BarnIcon,
  BookIcon,
  BottleIcon,
  ChampagneIcon,
  GlobeLocationIcon,
  MarketingIcon,
  NoteIcon,
  NuclearIcon,
  OctopusIcon,
  PaletteIcon,
  RoadSignIcon,
  TractorIcon,
  TrophyIcon,
} from '../../../assets/icons';

function AboutWine({ wine }) {
  const tempFeatures = wine?.attributes.publicData;
  const features = [
    {
      title: 'Winery',
      info: tempFeatures.wineryName,
      Icon: BarnIcon,
    },
    {
      title: 'Type',
      info: tempFeatures.type,
      Icon: PaletteIcon,
    },
    {
      title: 'Varietal',
      info: tempFeatures.varietal,
      Icon: ChampagneIcon,
    },
    // {
    //   title: 'Wine Rating',
    //   info: 'bottle ratine here',
    //   Icon: MarketingIcon
    // },
    {
      title: 'Region',
      info: tempFeatures.region,
      Icon: RoadSignIcon,
    },
    // {
    //   title: 'Awards',
    //   info: "Award",
    //   Icon: TrophyIcon
    // },
    {
      title: 'State',
      info: tempFeatures.state,
      Icon: GlobeLocationIcon,
    },
    {
      title: 'Tasting Notes',
      info: wine?.attributes.description,
      Icon: NoteIcon,
    },
    {
      title: 'Alcohol Content',
      info: tempFeatures.alcohol,
      Icon: NuclearIcon,
    },
    {
      title: 'Pairing Suggestions',
      info: tempFeatures.pairingsuggestions,
      Icon: OctopusIcon,
    },
    {
      title: 'Allergies',
      info: tempFeatures.allergies,
      Icon: AlertIcon,
    },
    {
      title: 'Recipe',
      info: tempFeatures.recipesuggestions,
      Icon: BookIcon,
    },
    {
      title: '100% Texas Fruit',
      info: tempFeatures.localfruit ? 'Yes' : 'No',
      Icon: TractorIcon,
    },
    {
      title: 'Bottle Size',
      info: tempFeatures.bottlesize,
      Icon: BottleIcon,
    },
  ];

  console.log('features', features);
  return (
    <div className={css.aboutWineContainer}>
      <h1>Facts About Wine</h1>
      <div className={css.wineFeaturesList}>
        <div>
          {features.slice(0, 7).map((f, index) => (
            <>
              {f.info ? (
                <div key={index} className={css.featuresListItem}>
                  <span
                  // style={{width: '30px', height: '30px'}}
                  >
                    <f.Icon />
                  </span>
                  <span className={css.itemInfo}>
                    <span className={css.itemInfoTitle}>{f.title}: </span>
                    {f.info}
                  </span>
                </div>
              ) : null}
            </>
          ))}
        </div>
        <div>
          {features.slice(7, 12).map((f, index) => (
            <>
              {f.info ? (
                <div key={index} className={css.featuresListItem}>
                  <span
                  // style={{width: '30px', height: '30px'}}
                  >
                    <f.Icon />
                  </span>
                  <span className={css.itemInfo}>
                    <span className={css.itemInfoTitle}>{f.title}: </span>
                    {f.info}
                  </span>
                </div>
              ) : null}
            </>
          ))}
        </div>
      </div>
    </div>
  );
}

export default AboutWine;
